// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__bt89P","success":"styles_success__3Ll9G","icon":"styles_icon__1esd6"};